import { TablesInsert } from '@/lib/supabase/supabase_types_override';
import { AirtableFields } from '@/types/crm/airtable/fields';

export function normalizeAirtableFields(
  column: AirtableFields,
  questionData: Partial<TablesInsert<'question'>>
): TablesInsert<'question'> {
  if (!questionData?.survey_id)
    throw new Error('No Survey Id provided in questionData');
  let questionRes: TablesInsert<'question'> = {
    question: column.name,
    field_type: column.type,
    crm_system: 'airtable',
    survey_id: questionData.survey_id,
    field_type_context_stack: [
      {
        field_type: column.type,
        crm_system: 'airtable',
      },
    ],
    selected_configuration: {
      parameter: [
        {
          id: 'Column Name',
          value: column.name,
        },
      ],
    },
    field_options: [],
    field_date_options: {},
  };
  if(column.type === 'number' || column.type === 'currency' || column.type === 'percent' || column.type === 'duration_days'){
      questionRes = {
        ...questionRes,
        field_decimal_places: column.options.precision
      };
  }
  if (column.type === 'checkbox') {
    questionRes = {
      ...questionRes,
      field_min_label: 'No',
      field_max_label: 'Yes',
    };
  }
  if (column.type === 'multipleSelects' || column.type === 'singleSelect') {
    questionRes = {
      ...questionRes,
      field_options: column.options.choices.map((o) => ({
        label: o.name,
        value: o.name,
      })),
    };
  }
  if (column.type === 'duration_hours') {
    questionRes = {
      ...questionRes,
      field_date_options: {
        durationFormat: column.options.durationFormat
      }
    };
  }
  return questionRes;
}
